import { Component, Injector, Input } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitService, SystemMessageService } from 'assets-service';
import { SystemMessage } from 'assets-model';
import { SystemMessageSearchComponentBase } from './system-message-search.component.base';


type SystemMessageSearchMode = 'popup' | 'normal';

@Component({
  selector: 'app-system-message-search',
  templateUrl: './system-message-search.component.html',
  styleUrls: ['./system-message-search.component.scss']
})
export class SystemMessageSearchComponent extends SystemMessageSearchComponentBase {


  @Input('mode') mode: SystemMessageSearchMode = 'normal';


  displayedColumns = ['businessUnit.buId', 'message', 'expiryDate', 'actions']

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected systemMessageService: SystemMessageService,
    protected businessUnitService: BusinessUnitService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, systemMessageService, businessUnitService, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  allowsEdit(element: SystemMessage) {
    return false;
  }

  allowsView(element: SystemMessage) {
    return false;
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}



